import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useSnackbar } from "notistack";
import { FaCopy, FaWhatsapp, FaEdit, FaTrash, FaUserSecret } from "react-icons/fa";
import { startImpersonation } from "../utils/impersonation";

const Atletas = () => {
  const [atleta, setAtleta] = useState([]);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleSimular = (item, target = "/ar/shop") => {
    enqueueSnackbar(`Iniciando navegação como ${item.nome} (logs desativados)...`, {
      variant: "info",
    });
    startImpersonation(item, target);
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/atletas`)
      .then((response) => {
        setAtleta(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, []);

  const [copiedId, setCopiedId] = useState(null);

  const copyToClipboard = async (text) => {
    if (!text) return false;
    // 1. Tenta API moderna do Clipboard se disponível
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (_) {}
    }

    // 2. Fallback robusto usando textarea invisível
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = "0";
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);
      return successful;
    } catch (err) {
      console.error("Falha ao copiar:", err);
      return false;
    }
  };

  const handleCopyLink = async (item) => {
    const key = item.chaveAcesso || item.password;
    const url = `${window.location.origin}/#/acesso?k=${key}`;
    const success = await copyToClipboard(url);

    if (success) {
      setCopiedId(item._id);
      setTimeout(() => setCopiedId(null), 2000);
      enqueueSnackbar("Link de acesso direto copiado!", {
        variant: "success",
      });
    } else {
      enqueueSnackbar("Não foi possível copiar automaticamente. Selecione e copie a URL.", {
        variant: "warning",
      });
    }
  };

  return (
    <div className="px-4 py-8 max-w-7xl mx-auto mt-16">
      <Link
        to="/admin/atletas/create"
        className="bg-green-600 hover:bg-green-900 py-2 mb-6 px-4 font-medium rounded-lg 
                              shadow-md text-base-100 inline-block"
      >
        Adicionar usuário
      </Link>
      <div className="overflow-x-auto">
        <table className="table mt-4">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Código de Acesso</th>
              <th>URL Direta</th>
              <th>E-mail</th>
              <th>Celular</th>
              <th>Perfil</th>
              <th>Representa</th>
              <th>Ações</th>
            </tr>
          </thead>

          <tbody>
            {atleta.map((item) => (
              <tr key={item._id} className="bg-base-100 hover:bg-base-300">
                <td className="py-3 px-5 font-medium">{item.nome}</td>
                <td className="py-3 px-5 font-mono font-semibold text-primary">
                  {item.password}
                </td>
                <td className="py-3 px-5">
                  <button
                    type="button"
                    onClick={() => handleCopyLink(item)}
                    title="Copiar link com chave segura direta"
                    className={`btn btn-xs gap-1 transition-all ${
                      copiedId === item._id
                        ? "btn-success text-white"
                        : "btn-outline btn-primary"
                    }`}
                  >
                    <FaCopy className="text-xs" />
                    <span>{copiedId === item._id ? "✓ Copiado" : "Copiar Link"}</span>
                  </button>
                </td>
                <td className="py-3 px-5">{item.email || "-"}</td>
                <td className="py-3 px-5 font-mono">{item.celular || "-"}</td>
                <td className="py-3 px-5">{item.perfil}</td>
                <td
                  className="py-3 px-5 text-xs max-w-xs truncate"
                  title={
                    Array.isArray(item.atletasRepresentados) &&
                    item.atletasRepresentados.length > 0
                      ? item.atletasRepresentados
                          .map((a) =>
                            typeof a === "object" && a !== null ? a.nome : "Atleta"
                          )
                          .join(", ")
                      : ""
                  }
                >
                  {Array.isArray(item.atletasRepresentados) &&
                  item.atletasRepresentados.length > 0
                    ? item.atletasRepresentados
                        .map((a) =>
                          typeof a === "object" && a !== null ? a.nome : "Atleta"
                        )
                        .join(", ")
                    : "-"}
                </td>
                <td className="py-3 px-5">
                  <div className="flex justify-center gap-x-1.5 items-center">
                    <button
                      type="button"
                      onClick={() => handleSimular(item, "/ar/shop")}
                      className="bg-indigo-600 hover:bg-indigo-800 text-white py-2 px-3 font-medium rounded-lg text-sm flex items-center gap-1 shadow-sm transition-all"
                      title={`Navegar na loja como ${item.nome}`}
                    >
                      <FaUserSecret />
                      <span>Simular</span>
                    </button>

                    <Link
                      to={`/admin/atletas/edit/${item._id}`}
                      className="bg-orange-500 hover:bg-orange-900
                 text-white py-2 px-3 font-medium rounded-lg text-sm flex items-center gap-1"
                      title="Editar atleta"
                    >
                      <FaEdit />
                      <span>Editar</span>
                    </Link>

                    <Link
                      to={`/admin/atletas/delete/${item._id}/${encodeURIComponent(item.nome)}`}
                      className="bg-red-500 hover:bg-red-900
                 text-white py-2 px-3 font-medium rounded-lg text-sm flex items-center gap-1"
                      title="Remover atleta"
                    >
                      <FaTrash />
                      <span>Remover</span>
                    </Link>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

//!

export default Atletas;
